export default __webpack_public_path__ + "static/checkpoint-9475cc6558d0574ff76a8a27faae1223.jpg";